import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ScrapDrawer from "./modules/ScrapDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'ScrapList',
  mixins: [JeecgListMixin],
  components: {
    ScrapDrawer: ScrapDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/asset/scrap',
      pageTitle: '资产报废',
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '设备编号',
        align: 'center',
        dataIndex: 'assetCode',
        scopedSlots: {
          customRender: 'assetCode'
        }
      }, {
        title: '出厂编号',
        align: 'center',
        dataIndex: 'sn',
        scopedSlots: {
          customRender: 'sn'
        }
      }, {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName'
      }, {
        title: '供应商',
        align: 'center',
        dataIndex: 'companyName'
      }, {
        title: '规格型号',
        align: 'center',
        dataIndex: 'model'
      }, {
        dataIndex: 'stime',
        colName: 'stime',
        title: '报废时间',
        align: 'center',
        sorter: true
      }, {
        title: '报废到期日',
        align: 'center',
        dataIndex: 'warrantyEnd'
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '报废原因',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '报废人',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  props: {
    category: {
      type: Number,
      default: 11
    },
    title: {
      type: String,
      default: '设备'
    }
  },
  created: function created() {
    this.queryParam.category = this.category;
    this.loadData();
  },
  computed: {},
  methods: {
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        category: this.category
      };
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData();
    },
    onDateStime: function onDateStime(value, dateArray) {
      this.queryParam.stimeStart = dateArray[0];
      this.queryParam.stimeEnd = dateArray[1];
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.edit(record); //console.log(record)

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    }
  }
};